import { useEffect } from "react";
import { useLocation } from "react-router";

/** New page → top; "/#katalog"-style links → that section. */
export function useScrollRestoration(): void {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
}
